module.exports = __webpack_public_path__ + "static/Mewshi@2x.acb494c5.png";